// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-stack {
  display: flex;
  flex-direction: row;
}
.row-stack.spacing-4px > :not(:first-child) {
  margin-left: 4px;
}
.row-stack.spacing-8px > :not(:first-child) {
  margin-left: 8px;
}
.row-stack.spacing-12px > :not(:first-child) {
  margin-left: 12px;
}
.row-stack.spacing-16px > :not(:first-child) {
  margin-left: 16px;
}
.row-stack.spacing-32px > :not(:first-child) {
  margin-left: 32px;
}

.row-stack-between {
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Row.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AAEI;EACE,gBAAA;AAAN;AAII;EACE,gBAAA;AAFN;AAMI;EACE,iBAAA;AAJN;AAQI;EACE,iBAAA;AANN;AAUI;EACE,iBAAA;AARN;;AAaA;EAEE,8BAAA;AAXF","sourcesContent":[".row-stack {\r\n  display: flex;\r\n  flex-direction: row;\r\n\r\n  &.spacing-4px{\r\n    > :not(:first-child) {\r\n      margin-left: 4px;\r\n    }\r\n  }\r\n  &.spacing-8px{\r\n    > :not(:first-child) {\r\n      margin-left: 8px;\r\n    }\r\n  }\r\n  &.spacing-12px{\r\n    > :not(:first-child) {\r\n      margin-left: 12px;\r\n    }\r\n  }\r\n  &.spacing-16px{\r\n    > :not(:first-child) {\r\n      margin-left: 16px;\r\n    }\r\n  }\r\n  &.spacing-32px{\r\n    > :not(:first-child) {\r\n      margin-left: 32px;\r\n    }\r\n  }\r\n}\r\n\r\n.row-stack-between\r\n{\r\n  justify-content: space-between;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
